import { SupervisorEnrollmentRequest } from '../../lib/types/models/trip-folder/enrollment-supervisor-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignSupervisorToEnrollment(input: SupervisorEnrollmentRequest) {
  const { tripFolderId, enrollmentId, supervisorId, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.tripFolder.assignSupervisor.url, {
        id: tripFolderId,
        enrollmentId,
        supervisorId
      })
    )
    .post(rest)
}
